import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/casa-trabalhador',
		component: Base,
		children: [
			{
				path: '',
				name: 'CasaTrabalhadorList',
				component: List,
				meta: {
					path: '/site/casa-trabalhador',
					pai: 'Site',
					title: 'Admin - Casa do Trabalhador',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Casa do Trabalhador',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'CasaTrabalhadorNovo',
				component: Form,
				meta: {
					path: '/site/casa-trabalhador',
					pai: 'Site',
					title: 'Admin - Casa do Trabalhador - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Casa do Trabalhador',
						class: '',
						active: false,
						url: '/site/casa-trabalhador'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'CasaTrabalhadorEditar',
				component: Form,
				meta: {
					path: '/site/casa-trabalhador',
					pai: 'Site',
					title: 'Admin - Casa do Trabalhador - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Casa do Trabalhador',
						class: '',
						active: false,
						url: '/site/casa-trabalhador'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]
